import styled from 'styled-components';
import { baseTheme } from '../../../../../../../../global/styles/theme';

export const PanelContainer = styled.div<{
  accentColor: string;
  accentBackground: string;
  accentBorder: string;
}>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid ${({ accentBorder }) => accentBorder};
  background: ${({ accentBackground }) => accentBackground};

  .panel-title {
    font-size: 14px;
    font-weight: 700;
    color: ${({ accentColor }) => accentColor};
    text-align: center;
  }

  .panel-hint {
    font-size: 12px;
    line-height: 1.4;
    color: ${baseTheme.colors.secondary};
    text-align: center;
  }

  .panel-actions {
    display: flex;
    gap: 8px;

    .panel-button {
      flex: 1;
      padding: 10px;
      border-radius: 10px;
      border: none;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;

      &.cancel {
        border: 1px solid ${baseTheme.colors.stroking};
        background: ${baseTheme.colors.white};
        color: ${baseTheme.colors.secondary};
      }

      &.confirm {
        flex: 2;
        color: ${baseTheme.colors.white};
      }

      &.confirm:disabled {
        background: ${baseTheme.colors.disabled};
        cursor: not-allowed;
      }
    }
  }
`;

export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  .ordered {
    font-size: 13px;
    color: ${baseTheme.colors.tertiary};
  }

  .count {
    min-width: 48px;
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    line-height: 1;
  }

  .count-button {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    border: 2px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.white};
    font-size: 24px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
    cursor: pointer;

    &:disabled {
      color: ${baseTheme.colors.disabled};
      cursor: not-allowed;
    }
  }
`;

export const PanelInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${baseTheme.colors.stroking};
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: ${baseTheme.colors.mainLightBlue};
  }
`;

export const ReasonsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  .reason-button {
    padding: 10px 8px;
    border-radius: 10px;
    border: 2px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.white};
    font-size: 13px;
    font-weight: 600;
    color: ${baseTheme.colors.secondary};
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s;

    &.selected {
      border-color: ${baseTheme.colors.purple};
      color: ${baseTheme.colors.purple};
    }
  }
`;
